import { render, staticRenderFns } from "./SopCollapseItem.vue?vue&type=template&id=f508f17c&scoped=true&"
import script from "./SopCollapseItem.vue?vue&type=script&lang=js&"
export * from "./SopCollapseItem.vue?vue&type=script&lang=js&"
import style0 from "./SopCollapseItem.vue?vue&type=style&index=0&id=f508f17c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f508f17c",
  null
  
)

export default component.exports